module.exports = __webpack_public_path__ + "img/theme-candena_logo-grey.26ebcd19.png";